import { LAB_HEADLINE } from "./copy";
import { DAWN_ID, DAWN_NAME } from "./worlds/dawn";
import { LAMP_ID, LAMP_NAME } from "./worlds/lamp";
import { POCKET_ID, POCKET_NAME } from "./worlds/pocket";

export const DESIGNS = [DAWN_ID, POCKET_ID, LAMP_ID] as const;
export type Design = (typeof DESIGNS)[number];

export const LAB_SCREENS = [
  { id: "landing", label: "Главная" },
  { id: "exercise", label: "Занятие" },
] as const;

export type LabScreen = (typeof LAB_SCREENS)[number]["id"];

export type CheckoutScene = "idle" | "success" | "failure" | "cancel";

export interface DirectorState {
  firstWrong: boolean;
  hintOpen: boolean;
  offline: boolean;
  trialEnded: boolean;
  reducedMotion: boolean;
  smallCohort: boolean;
  checkout: CheckoutScene;
}

export const DEFAULT_DIRECTOR: DirectorState = {
  firstWrong: false,
  hintOpen: false,
  offline: false,
  trialEnded: false,
  reducedMotion: false,
  smallCohort: false,
  checkout: "idle",
};

export const WORLD_NAME: Record<Design, string> = {
  dawn: DAWN_NAME,
  pocket: POCKET_NAME,
  lamp: LAMP_NAME,
};

export const WORLD_PROMISE: Record<Design, string> = {
  dawn: LAB_HEADLINE,
  pocket: LAB_HEADLINE,
  lamp: LAB_HEADLINE,
};

export const CHECKOUT_COPY: Record<Exclude<CheckoutScene, "idle">, string> = {
  success: "Тестовый доступ включён. Деньги не списаны.",
  failure: "Сценарий отказа выполнен. Доступ не изменился, деньги не списаны.",
  cancel: "Оформление отменено. Доступ и прогресс не изменились.",
};

export function isDesign(value: string | null): value is Design {
  return value === DAWN_ID || value === POCKET_ID || value === LAMP_ID;
}

export function isLabScreen(value: string | null): value is LabScreen {
  return LAB_SCREENS.some((screen) => screen.id === value);
}

export function labBasePath(pathname: string): string {
  return pathname.startsWith("/admin/design-lab") ? "/admin/design-lab" : "/design-lab";
}

export function parseLabSearch(search: string): { design: Design | null; screen: LabScreen } {
  const query = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const design = query.get("design");
  const screen = query.get("screen");
  return {
    design: isDesign(design) ? design : null,
    screen: isLabScreen(screen) ? screen : "landing",
  };
}

export function labHref(basePath: string, design?: Design | null, screen: LabScreen = "landing"): string {
  if (!design) return basePath;
  return `${basePath}?design=${design}&screen=${screen}`;
}
